/**
 * @generated SignedSource<<4120c0a0e4b26bbf09001b0c7ab8e1c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type formatCreatorsAttribute_viewer$data = {
  readonly creatorProperties: ReadonlyArray<{
    readonly name: string | null;
    readonly propertyName: string | null;
    readonly urlLabel: string | null;
  } | null> | null;
  readonly " $fragmentType": "formatCreatorsAttribute_viewer";
};
export type formatCreatorsAttribute_viewer$key = {
  readonly " $data"?: formatCreatorsAttribute_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"formatCreatorsAttribute_viewer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "formatCreatorsAttribute_viewer"
};

(node as any).hash = "948f2b76576ba83a7ad54fb0a2098f7c";

export default node;
